import { Button, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

type Props = {
  retry?: () => void;
};

export default function ErrorSection({ retry }: Props) {
  const { t } = useTranslation();

  return (
    <Stack alignItems="center">
      <Text>{t("common.labels.an_error_occurred")}</Text>
      {retry && (
        <Button variant="ghost" onClick={retry}>
          {t("common.buttons.try_again")}
        </Button>
      )}
    </Stack>
  );
}
